import React, {Component } from 'react'

export class PopUpmessage extends Component{
   
    constructor(){
        super();
    }

    render(){
        if(this.props.type=='success'){
            return(
            
                <div className={'success-box msg-box ' +this.props.IsShowMessagePopup}><i className="sprite msg-icon success-icon"></i><label id="sucessMsg">{this.props.PopUpmessage}</label></div>
    
            )
        }else{
            return(
            
                 <div className={'alert-box msg-box '+this.props.IsShowMessagePopup}><i className="sprite msg-icon alert-icon"></i><label id="errorMsg"></label>{this.props.PopUpmessage}<a href="#" id="clickHere"></a></div> 
    
            )
        }
        
    }

}

export default PopUpmessage;